import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/kombit.png'
import _imports_1 from '@/assets/mitid.png'
import _imports_2 from '@/assets/european.png'
import _imports_3 from '@/assets/user-slash-solid.svg'


const _hoisted_1 = { class: "appension" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Vi fandt ")
const _hoisted_4 = { class: "text-primary" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" brugere")
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "d-flex align-items-center gap-2" }
const _hoisted_8 = {
  key: 0,
  style: {"width":"25px"},
  src: _imports_0
}
const _hoisted_9 = {
  key: 1,
  style: {"width":"50px"},
  src: _imports_1
}
const _hoisted_10 = {
  key: 2,
  style: {"width":"30px"},
  src: _imports_2
}
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = {
  class: "d-flex",
  style: {"gap":"10px"}
}
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = {
  class: "d-flex",
  style: {"gap":"10px"}
}
const _hoisted_17 = { class: "text-muted" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = {
  class: "d-flex",
  style: {"gap":"10px"}
}
const _hoisted_22 = { class: "text-muted" }
const _hoisted_23 = {
  key: 0,
  style: {"width":"25px"},
  src: _imports_3
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_error = _resolveComponent("error")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_User = _resolveComponent("User")!
  const _component_page = _resolveComponent("page")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_page, {
      isLoading: _ctx.loading,
      error: _ctx.error || undefined
    }, {
      default: _withCtx(() => [
        (_ctx.users)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_app_header, {
                  titleButtonIcon: undefined,
                  searchPlaceholder: "Indtast fornavn, efternavn eller mailadresse...",
                  canSearch: true,
                  searchEntry: _ctx.searchText,
                  "onUpdate:searchEntry": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchText = $event)),
                  title: 'Profilsøgning'
                }, {
                  subtitle: _withCtx(() => [
                    (_ctx.users)
                      ? (_openBlock(), _createBlock("strong", _hoisted_2, [
                          _hoisted_3,
                          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.users.total), 1),
                          _hoisted_5
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["searchEntry"]),
                _createVNode(_component_DataTable, {
                  sortField: "firstname",
                  sortOrder: 1,
                  responsiveLayout: "scroll",
                  dataKey: "userId",
                  value: _ctx.users?.items ?? [],
                  class: "bg-white rounded",
                  onRowClick: _cache[2] || (_cache[2] = ($event: any) => (
            _ctx.canManageUsers ? _ctx.userSidebar.showUserSidebar($event.data) : null
          )),
                  selectionMode: "single"
                }, {
                  empty: _withCtx(() => [
                    _createVNode(_component_error, {
                      error: {
                title: _ctx.searchText ? 'Ingen resultater' : 'Ingen brugere',
                message: _ctx.searchText
                  ? 'Din søgning gav ingen resultater'
                  : 'Der er ikke nogle brugere oprettet endnu',
              }
                    }, null, 8, ["error"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "adminIcon",
                      style: {"width":"50px","padding-right":"unset"}
                    }, {
                      body: _withCtx((slotProps) => [
                        _withDirectives(_createVNode("div", _hoisted_6, [
                          (slotProps.data.administrator)
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                icon: ['fas', 'crown']
                              }))
                            : _createCommentVNode("", true)
                        ], 512), [
                          [
                            _directive_tooltip,
                            'Lokal administrator',
                            void 0,
                            { top: true }
                          ]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "externalIcon",
                      style: {"width":"120px","padding-right":"16px","padding-left":"16px"}
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("div", _hoisted_7, [
                          (slotProps.data.kombitID)
                            ? _withDirectives((_openBlock(), _createBlock("img", _hoisted_8, null, 512)), [
                                [
                                  _directive_tooltip,
                                  'Kombit',
                                  void 0,
                                  { top: true }
                                ]
                              ])
                            : _createCommentVNode("", true),
                          (slotProps.data.mitID)
                            ? _withDirectives((_openBlock(), _createBlock("img", _hoisted_9, null, 512)), [
                                [
                                  _directive_tooltip,
                                  'MitID',
                                  void 0,
                                  { top: true }
                                ]
                              ])
                            : _createCommentVNode("", true),
                          (slotProps.data.eID)
                            ? _withDirectives((_openBlock(), _createBlock("img", _hoisted_10, null, 512)), [
                                [
                                  _directive_tooltip,
                                  'eID',
                                  void 0,
                                  { top: true }
                                ]
                              ])
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { field: "firstname" }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("div", _hoisted_11, [
                          _withDirectives(_createVNode("strong", null, [
                            _createTextVNode(_toDisplayString(slotProps.data.firstname) + " " + _toDisplayString(slotProps.data.lastname), 1)
                          ], 512), [
                            [
                              _directive_tooltip,
                              'Navn',
                              void 0,
                              { top: true }
                            ]
                          ]),
                          (slotProps.data.isAdministrator)
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                class: "ms-3 appension-icon",
                                icon: ['fas', 'crown']
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { field: "email" }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("div", _hoisted_12, [
                          _createVNode("div", _hoisted_13, [
                            _withDirectives(_createVNode("span", _hoisted_14, [
                              _createTextVNode(_toDisplayString(slotProps.data.email), 1)
                            ], 512), [
                              [
                                _directive_tooltip,
                                'E-mail',
                                void 0,
                                { top: true }
                              ]
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "creationDate",
                      header: "Oprettet",
                      style: {"padding":"unset"}
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("div", _hoisted_15, [
                          _createVNode("div", _hoisted_16, [
                            _withDirectives(_createVNode("span", _hoisted_17, [
                              _createTextVNode(_toDisplayString(_ctx.displayUserCreationDate(
                      slotProps.data.creationDate,
                      slotProps
                    )), 1)
                            ], 512), [
                              [
                                _directive_tooltip,
                                'Oprettet',
                                void 0,
                                { top: true }
                              ]
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "totalDays",
                      header: "Seneste login",
                      style: {"width":"150px"}
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("div", _hoisted_18, [
                          _withDirectives(_createVNode("span", _hoisted_19, [
                            _createTextVNode(_toDisplayString(_ctx.totalDaysSinceLastLogin(slotProps.data.lastLogin)), 1)
                          ], 512), [
                            [
                              _directive_tooltip,
                              'Seneste login',
                              void 0,
                              { top: true }
                            ]
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { field: "organization" }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("div", _hoisted_20, [
                          _createVNode("div", _hoisted_21, [
                            _withDirectives(_createVNode("span", _hoisted_22, [
                              _createTextVNode(_toDisplayString(slotProps.data.organization?.name || "Ingen organisation"), 1)
                            ], 512), [
                              [
                                _directive_tooltip,
                                'Organisation',
                                void 0,
                                { top: true }
                              ]
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { field: "disabled" }, {
                      body: _withCtx((slotProps) => [
                        (slotProps.data.disabled)
                          ? _withDirectives((_openBlock(), _createBlock("img", _hoisted_23, null, 512)), [
                              [
                                _directive_tooltip,
                                'Deaktiveret',
                                void 0,
                                { top: true }
                              ]
                            ])
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createVNode(_component_Pagination, {
                  rows: _ctx.pageParams.pageSize,
                  totalRecords: _ctx.users.total,
                  page: _ctx.pageParams.currentPage! - 1,
                  onPageChange: _ctx.onPageChange
                }, null, 8, ["rows", "totalRecords", "page", "onPageChange"])
              ]),
              (_ctx.userSidebar.selectedUser.value && !_ctx.userSidebar.isHiding.value)
                ? (_openBlock(), _createBlock(_component_User, {
                    key: `user-${_ctx.userSidebar.selectedUser.value?.userId || 'new'}`,
                    id: _ctx.userSidebar.selectedUser?.value?.userId ?? '',
                    "organization-id": 
          _ctx.userSidebar.selectedUser?.value?.organization?.organizationId ?? ''
        ,
                    onHide: _ctx.userSidebar.hideUserSidebar,
                    onUserDeleted: _ctx.onUserDeleted
                  }, null, 8, ["id", "organization-id", "onHide", "onUserDeleted"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isLoading", "error"])
  ], 64))
}